export default __webpack_public_path__ + "static/media/spin.27c6b828.svg";